/** docs at http://animejs.com/documentation/ */
import anime from 'animejs';

export const EVENTS = {
  INIT: 'init',
};

/** default options */
// anime({
//     duration: 1000,
//     delay: 0,
//     easing: 'easeOutElastic',
//     elasticity: 500,
//     round: false,
// });

const defaultConfig = {
  settingsAttr: 'data-animate',
};

const defaultSettings = {
  events: EVENTS.INIT,
  children: null,
  options: {
    easing: 'easeOutQuad',
  },
};

class Animate {
  constructor(element, config) {
    this.element = element;
    this.config = { ...defaultConfig, ...config };

    this.settings = [];
    this.timeline = null;
    this.animation = null;

    this.animate = this.animate.bind(this);
    this.init = this.init.bind(this);

    this.init();

    return this;
  }

  init() {
    const elementSettings = JSON.parse(
      this.element.getAttribute(this.config.settingsAttr)
    );

    elementSettings.forEach(setting => {
      const animSettings = { ...defaultSettings, ...setting };
      if (animSettings.children) {
        animSettings.children = this.element.querySelectorAll(setting.children);
      }
      if (Array.isArray(setting.options)) {
        animSettings.options = [defaultSettings.options];

        setting.options.forEach(opt => {
          animSettings.options = [
            ...animSettings.options,
            { ...defaultSettings.options, ...opt },
          ];
        });
      } else {
        animSettings.options = {
          ...defaultSettings.options,
          ...setting.options,
        };
      }

      this.settings = [...this.settings, animSettings];
      this.addListeners(animSettings);
    });
  }

  addListeners({ events, children, options }) {
    if (!events) return false;

    return events.split(' ').map(event => {
      if (event === EVENTS.INIT) {
        this.animate(children, options);
      } else {
        this.element.addEventListener(event, e => {
          e.stopPropagation();
          this.animate(children, options);
        });
      }
      return true;
    });
  }

  animate(children, options) {
    if (Array.isArray(options)) {
      const tl = anime.timeline(options.shift());
      this.destroy(this.timeline);
      options.forEach(opt => {
        tl.add({
          targets: children || this.element,
          ...opt,
        });
      });
      this.timeline = tl;
    } else {
      this.destroy(this.animation);
      this.animation = anime({
        targets: children || this.element,
        ...options,
      });
    }
  }

  destroy(animation) {
    if (!animation) return;

    if (Array.isArray(animation)) {
      this.destroyed = animation.map(anim =>
        anim.animatables.map(({ target }) => anime.remove(target))
      );
    } else {
      this.destroyed = animation.animatables.map(({ target }) =>
        anime.remove(target)
      );
    }
  }

  update() {
    this.destroy();
    this.init();
  }
}

export default Animate;



// WEBPACK FOOTER //
// ./src/scripts/modules/Animate.js